/* eslint-disable @typescript-eslint/no-explicit-any */
import {CreateEntityRequest} from "../model/request/entity/CreateEntityRequest.ts";
import {BaseService} from "./BaseService.ts";
import {UpdateEntity} from "../model/request/entity/UpdateEntity.ts";
import {CreateBulkEntityRequest} from "../model/request/entity/CreateBulkEntityRequest.ts";
import {DeleteEntityRequest} from "../model/request/entity/DeleteEntityRequest.ts";
import {ReadEntityByApplicationId} from "../model/request/entity/ReadEntityByApplicationId.ts";

export class EntityService {
    static create = (others: any, data: CreateEntityRequest) => {
        return BaseService.apiClient(others).post("/entity/create", data);
    };
    static readByEntityApplicationId = (others: any, data: ReadEntityByApplicationId) => {
        return BaseService.apiClient(others).get(`/entity/read-by-entity-application-id/${data.entityApplicationId}`);
    };
    static read = (others: any) => {
        return BaseService.apiClient(others).get("/entity/read");
    };
    static update = (others: any, data: UpdateEntity) => {
        return BaseService.apiClient(others).post("/entity/update", data);
    };
    static bulkCreate = (others: any, data: CreateBulkEntityRequest) => {
        return BaseService.apiClient(others).post("/bulk-entity/bulk-create", data);
    };
    static delete = (others: any, data: DeleteEntityRequest) => {
        return BaseService.apiClient(others).post("/entity/delete", data);
    };
}
